import { WebLinkProps } from '../app-kit/components/WebLink/WebLink';
import { mapApiWeblinkIconInfoToLinkIconInfo } from '../app-kit/helpers/mapApiWeblinkIconInfoToLinkIconInfo';
import { mapApiWeblinkVariantToLinkVariant } from '../app-kit/helpers/mapApiWeblinkVariantToLinkVariant';
import { mapBadgeVariant } from '../app-kit/helpers/mapBadgeVariant';
import { WebLinkFragment } from '../types';

export const mapWebLinkFragmentToWebLinkProps = (webLink: WebLinkFragment): WebLinkProps => ({
  ...webLink,
  variant: mapApiWeblinkVariantToLinkVariant(webLink.variant),
  iconInfo: webLink.iconInfo ? mapApiWeblinkIconInfoToLinkIconInfo(webLink.iconInfo) : null,
  callout: webLink.callout
    ? {
        ...webLink.callout,
        variant: mapBadgeVariant(webLink.callout.variant),
      }
    : null,
});
